module.exports = __webpack_public_path__ + "img/bot_father_icon.418339e9.jpg";